import { useState } from "react";
import axios from "axios";
import { ArrowRight, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !email.includes("@")) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      await axios.post(`${API}/newsletter`, { email });
      setSubmitted(true);
      setEmail("");
    } catch {
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <section
      data-testid="newsletter-section"
      className="py-24 md:py-32 bg-brand-bg-light"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center space-y-8">
        <p className="text-xs uppercase tracking-[0.3em] font-body font-semibold text-brand-gold">
          Stay Connected
        </p>
        <h2 className="font-heading text-3xl md:text-5xl font-light tracking-tight text-brand-primary">
          Join the Sartaj <span className="italic">Family</span>
        </h2>
        <p className="font-body text-base font-light text-brand-text-dark/60 max-w-lg mx-auto">
          Receive exclusive recipes, early access to new varieties, and stories
          from the world of premium basmati.
        </p>

        {submitted ? (
          <div
            data-testid="newsletter-success"
            className="flex items-center justify-center gap-3 text-brand-gold py-4"
          >
            <Check size={20} />
            <span className="font-body text-sm uppercase tracking-widest">
              Welcome to the Sartaj family
            </span>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            noValidate
            data-testid="newsletter-form"
            className="max-w-md mx-auto"
          >
            <div className="flex border-b border-brand-primary/20 focus-within:border-brand-gold transition-colors duration-300">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                data-testid="newsletter-email-input"
                className="flex-1 bg-transparent py-4 font-body text-sm text-brand-text-dark placeholder:text-brand-text-dark/30 focus:outline-none"
              />
              <button
                type="submit"
                data-testid="newsletter-submit-btn"
                className="px-4 text-brand-gold hover:text-brand-primary transition-colors duration-300"
              >
                <ArrowRight size={20} />
              </button>
            </div>
            {error && (
              <p
                data-testid="newsletter-error"
                className="text-red-500 text-xs mt-2 font-body text-left"
              >
                {error}
              </p>
            )}
          </form>
        )}
      </div>
    </section>
  );
};

export default Newsletter;
